export default __webpack_public_path__ + "static/media/rocket_anim_35.fa78ff73.png";